// EWM-530 — raw HTML/CSS/JS pass-through.
//
// Writes the editor's content into `container` verbatim, then upgrades the
// inert <script> tags the HTML parser produces (scripts inserted via
// innerHTML never run) into freshly-created script elements so the browser
// executes them on insertion. Attributes and text are copied so external
// (src) and inline scripts both behave as authored, and replaceWith keeps
// each script in its original DOM position relative to its siblings.
//
// NO sanitisation, escaping, or validation is applied — this is a deliberate
// "trust the editor" escape hatch (the opposite of organisms/seo-content).
export const renderRawHtml = (container: HTMLElement, code: string): void => {
  container.innerHTML = code ?? '';

  container.querySelectorAll('script').forEach((inert) => {
    const live = document.createElement('script');

    Array.from(inert.attributes).forEach(({ name, value }) => {
      live.setAttribute(name, value);
    });
    live.textContent = inert.textContent;

    inert.replaceWith(live);
  });
};
